import { VersionHistory, changeLog2021 } from "./logs";

const current: VersionHistory[] = Object.values(changeLog2021);

export default current;
